module.exports = __webpack_public_path__ + "img/ch59.9a33b7ca.jpg";